import m from "../../geodata/es2015/pakistanLow";
window.am4geodata_pakistanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/pakistanLow.js
// module id = null
// module chunks = 